import React, { useMemo } from "react";
import { Box, Grid } from "@mui/material";
import { StriimTypography } from "@striim/striim-ui-v2";
import { UserMessageProps } from "@copilotkit/react-ui";
import App from "app";

const sxStyles = {
    container: {
        background: "#EBF2FA !important",
        border: "1px solid #D8E4F0",
        borderRadius: "8px",
        padding: "8px",
        mt: 2,
        mb: 2
    },
    avatar: {
        width: "24px",
        height: "24px",
        background: " #EF5C77;",
        borderRadius: "8px",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    avatarText: {
        color: "#FFF",
        textAlign: "center",
        fontFamily: "Nunito",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "14px"
    }
};
const CustomUserMessage: React.FC<UserMessageProps> = ({ message, rawData }) => {
    const user = App.user || {};

    const avatarText = useMemo(() => {
        return user?.name?.charAt(0).toUpperCase() || "U";
    }, [user]);

    const content = message?.content || rawData?.content || "";
    return (
        <Box sx={sxStyles.container}>
            <Grid container gap={1.5} flexWrap={"nowrap"}>
                <Box sx={sxStyles.avatar}>
                    <StriimTypography sx={sxStyles.avatarText}>{avatarText}</StriimTypography>
                </Box>
                <Box sx={{ width: "90%", wordBreak: "break-word" }}>
                    <StriimTypography data-testid="user-message" variant="body4" color={"greyscale.700"}>
                        {content}
                    </StriimTypography>
                </Box>
            </Grid>
        </Box>
    );
};

export default CustomUserMessage;
